import { uniqueId } from 'lodash-es';

export type TooltipPosition = 'top' | 'bottom' | 'left' | 'right' | 'none';

export type TooltipTheme = 'light' | 'dark';

export interface TooltipConfig {
  position?: TooltipPosition;
  label: string;
  theme?: TooltipTheme;
  linebreaks?: boolean;
  width?: string;
  id?: string;
}

export const DEFAULT_TOOLTIP_CONFIG: TooltipConfig = {
  position: 'bottom',
  label: '',
  theme: 'light',
  linebreaks: false,
  id: uniqueId('tooltip'),
};
